import './searchPreviewAndDetails.scss';
import React, {Fragment, memo, useEffect, useState} from 'react';
import {
    useSelectedDocContext,
    useStateDocsCount,
    useStateQueryPending,
    useStateUpdateDocumentInProgress
} from '../search-hooks';
import {useTranslation} from 'react-i18next';
import {Icons} from '../../icons/icons';
import {SvgIcon} from '../../icons/svgIcon';
import {DrawerProps, HibuDrawer} from '../../common/drawer/hibuDrawer';
import classNames from 'clsx';
import {SearchPreview} from './search-preview/searchPreview';
import {SearchResultDetails} from './search-result-details/searchResultDetails';

export const SearchPreviewAndDetails = memo(() => {
    const {t} = useTranslation();
    const selectedDoc = useSelectedDocContext();
    const updateDocumentInProgress = useStateUpdateDocumentInProgress();
    const docsCount = useStateDocsCount();
    const queryPending = useStateQueryPending();
    const [showPreviewAndeDetails, setShowPreviewAndeDetails] = useState(false);

    useEffect(() => {
        setShowPreviewAndeDetails(!!selectedDoc); // toggling drawer on item click
    }, [selectedDoc]);

    const isNewQuery = () => {
        return queryPending && docsCount === 0;
    };

    const closeDrawer = () => {
        return setShowPreviewAndeDetails(false);
    };

    if (!selectedDoc) {
        const placeholderContent = () => (
            <div id="search-result-details">
                <>
                    <p className={'placeholder'}>{t('search.details.placeholder')}</p>
                </>
            </div>
        );
        return (
            <HibuDrawer
                id={'hibu_result_detail_column'}
                className={classNames('no-document-selected')}
                show={showPreviewAndeDetails}
                onCloseRequest={closeDrawer}
                contentCb={placeholderContent}
                contentLoading={updateDocumentInProgress}
            />
        );
    }

    const mobileHeaderCallback = ({onCloseRequest}: DrawerProps) => {
        return (
            <Fragment>
                <SvgIcon
                    className="details-header-close"
                    icon={Icons.X}
                    onClick={onCloseRequest}
                    alt={t('general.clear')}
                />
            </Fragment>
        );
    };

    const contentCallback = () => (
        <div id="search-preview-and-details">
            <div className="details-body">
                <SearchPreview></SearchPreview>
                <SearchResultDetails></SearchResultDetails>
            </div>
        </div>
    );

    return (
        <>
            {!isNewQuery() &&
                <HibuDrawer
                    id={'hibu_result_detail_column'}
                    show={showPreviewAndeDetails}
                    onCloseRequest={closeDrawer}
                    headerCbMobile={mobileHeaderCallback}
                    contentCb={contentCallback}
                    contentLoading={updateDocumentInProgress}
                />
            }
        </>
    );
});
